import { SHContainer, SHStack } from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import { SHToggleButtonOptionsSkeleton } from "@components/skeletons/design-systems/SHToggleButtonOptionsSkeleton";
import { TableAnalysisCellSkeleton } from "@components/skeletons/layouts/platform-analysis/table-analysis/TableAnalysisCellSkeleton";
import { StepNameSkeleton } from "@components/skeletons/layouts/stepper/StepNameSkeleton";
import { AnalysisSummaryStyleConfigs as Configs } from "@pages/platform-analysis-v2/_id/steps/summary/configs";

export const SummaryStepSkeleton = () => {
  return (
    <SHContainer maxWidth="lg2" sx={{ px: { xs: "16px", lg2: 0 }, py: "25px" }}>
      <SHStack gap={3}>
        <StepNameSkeleton delay={false} />

        <SHStack direction={"row"} gap={3}>
          <SHSkeleton width={100} height={100} delay={false} />

          <SHStack height={100} alignItems={"center"} justifyContent={"center"}>
            <SHStack
              gap={1}
              height={"100%"}
              alignItems={"flex-start"}
              justifyContent={"center"}
            >
              <SHSkeleton width={400} height={30} delay={false} />
              <SHStack gap={0.5}>
                <SHSkeleton width={800} height={20} delay={false} />
                <SHSkeleton width={700} height={20} delay={false} />
              </SHStack>
            </SHStack>
          </SHStack>
        </SHStack>

        <SHStack gap={1}>
          <SHSkeleton width={450} height={20} delay={false} />
          <SHSkeleton width={250} height={20} delay={false} />
        </SHStack>

        <SHStack gap={2}>
          <SHSkeleton width={100} height={20} delay={false} />
          <SHSkeleton width={"100%"} height={100} delay={false} />
        </SHStack>

        <SHStack gap={2}>
          <SHStack
            direction={"row"}
            width={"100%"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <SHSkeleton width={120} height={20} delay={false} />
            <SHToggleButtonOptionsSkeleton />
          </SHStack>

          <SHStack
            sx={{
              "& .MuiSkeleton-root": {
                width: "100% !important",
              },
            }}
            gap={1}
          >
            <SHStack
              width={"100%"}
              direction={"row"}
              alignItems={"center"}
              sx={{ overflow: "hidden" }}
            >
              <TableAnalysisCellSkeleton
                isTableHead
                isFirstColumn
                width={Configs.DefaultTitleColumnWidth}
                height={Configs.DefaultTableHeaderHeight}
              />

              <TableAnalysisCellSkeleton
                isTableHead
                width={Configs.TotalFeaturesSelectedColumnWidth}
                height={Configs.DefaultTableHeaderHeight}
              />

              {Array.from({ length: 4 }).map((_, index) => (
                <TableAnalysisCellSkeleton
                  key={index}
                  isTableHead
                  height={Configs.DefaultTableHeaderHeight}
                  width={Configs.DefaultProductColumnWidth}
                />
              ))}

              <TableAnalysisCellSkeleton
                isTableHead
                isLastColumn
                height={Configs.DefaultTableHeaderHeight}
                width={Configs.DefaultProductColumnWidth}
              />
            </SHStack>

            <SHStack width={"100%"} direction={"column"}>
              {Array.from({ length: 4 }).map((_, rowIndex) => (
                <SHStack key={rowIndex} direction={"row"} alignItems={"center"}>
                  <TableAnalysisCellSkeleton
                    isTableHead={rowIndex === 3}
                    width={Configs.DefaultTitleColumnWidth}
                    height={Configs.DefaultRowHeight}
                  />

                  <TableAnalysisCellSkeleton
                    isTableHead={rowIndex === 3}
                    width={Configs.TotalFeaturesSelectedColumnWidth}
                    height={Configs.DefaultRowHeight}
                  />

                  {Array.from({ length: 4 }).map((_, index) => (
                    <TableAnalysisCellSkeleton
                      key={index}
                      isTableHead={rowIndex === 3}
                      width={Configs.DefaultProductColumnWidth}
                      height={Configs.DefaultRowHeight}
                    />
                  ))}

                  <TableAnalysisCellSkeleton
                    isLastColumn
                    isTableHead={rowIndex === 3}
                    width={Configs.DefaultProductColumnWidth}
                    height={Configs.DefaultRowHeight}
                  />
                </SHStack>
              ))}
            </SHStack>
          </SHStack>
        </SHStack>

        <SHStack gap={2}>
          <SHSkeleton width={120} height={20} delay={false} />

          <SHStack
            width={"100%"}
            sx={{
              "& .MuiSkeleton-root": {
                width: "100% !important",
              },
            }}
          >
            {Array.from({ length: 3 }).map((_, index) => (
              <SHStack key={index} direction={"row"} width={"100%"}>
                <TableAnalysisCellSkeleton
                  isTableHead={index === 2}
                  height={Configs.DefaultRowHeight}
                  width={Configs.PortfolioDetailsTitleColumnWidth}
                />

                <TableAnalysisCellSkeleton
                  isLastColumn
                  isTableHead={index === 2}
                  height={Configs.DefaultRowHeight}
                  flex={1}
                />
              </SHStack>
            ))}
          </SHStack>
        </SHStack>
      </SHStack>
    </SHContainer>
  );
};
